import { createFileRoute } from "@tanstack/react-router";
import { TrackingPage } from "../track/TrackingPage";

function TrackRoute() {
  return <TrackingPage token={Route.useParams().token} />;
}

export const Route = createFileRoute("/track/$token")({
  component: TrackRoute,
});
